
import { WorldCountry } from '../types';
import { polandAdditionalCities } from './polandExpansion';

export const polandData: WorldCountry = {
  name: 'Poland',
  slug: 'poland',
  code: 'PL',
  population: 37846611,
  topCities: [
    { name: 'Warsaw', slug: 'warsaw', population: 1793579 },
    { name: 'Kraków', slug: 'krakow', population: 779115 },
    { name: 'Łódź', slug: 'lodz', population: 679941 },
    { name: 'Wrocław', slug: 'wroclaw', population: 643782 },
    { name: 'Poznań', slug: 'poznan', population: 535389 },
    { name: 'Gdańsk', slug: 'gdansk', population: 470633 },
    { name: 'Szczecin', slug: 'szczecin', population: 401907 },
    { name: 'Bydgoszcz', slug: 'bydgoszcz', population: 348190 },
    { name: 'Lublin', slug: 'lublin', population: 339850 },
    { name: 'Białystok', slug: 'bialystok', population: 297554 },
    ...polandAdditionalCities
  ]
};
